import { render, staticRenderFns } from "./FilterExpenses.vue?vue&type=template&id=8f2d803e&scoped=true"
import script from "./FilterExpenses.vue?vue&type=script&lang=js"
export * from "./FilterExpenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2d803e",
  null
  
)

export default component.exports